export default __webpack_public_path__ + "0a0ba034f67e3711a412cf8a8c5cf972.svg";